<template>
  <div id="taskBar">
    <div class="word">
      <slot name="tagging">
        <span>{{ tagging }}</span>
      </slot>
    </div>
    <div class="po"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "TaskBar",
  props: {
    tagging: String,
  },
};
</script>

<style scoped lang="less">
#taskBar {
  width: 8.125rem;
  height: 76vh;
  position: absolute;
  right: 0.75rem;
  bottom: 5.5%;
  border-radius: 0.28125rem;
  background: @main-bgc;
  box-shadow: @box-shadow;
  border: @main-border;
  .word {
    font-family: "PSYCHO";
    display: inline-block;
    margin: 0.2rem 0.125rem 0 0.3rem;
    cursor: pointer;
    span {
      font-size: 0.2rem;
      font-weight: 600;
      user-select: none;
    }
  }
  .po {
    margin: 0.3rem 0.125rem 0 0.125rem;
    height: 60vh;
    overflow: auto;

    //取消滚动条，分别是IE、Firefox、chrome/safari
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }
}
</style>